import { render, staticRenderFns } from "./SistemaConfig.vue?vue&type=template&id=7f413ff8&scoped=true&"
import script from "./SistemaConfig.vue?vue&type=script&setup=true&lang=js&"
export * from "./SistemaConfig.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f413ff8",
  null
  
)

export default component.exports